// @flow

import { connect } from 'react-redux';

import Rencontre, { type DispatchProps, type StateProps } from 'components/rencontre/Rencontre';

import { fetchPageList } from 'actions/pageActions';
import { fetchRencontre } from 'actions/rencontreActions';

import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
  status: state.rencontreState.status,
  statusPage: state.pageNodeState.status,
  sidebarContent: state.pageNodeState.pageNode.sidebar_content,
  album: state.albumState.album,
  organization: state.settingsState.title,
  club: state.settingsState.structure,
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
  fetchRencontre: (id: string, slugEquipe?: string) => dispatch(fetchRencontre(id, slugEquipe)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rencontre);
